<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Create a channel</p>
        </header>
        <section class="modal-card-body">
            <o-field label="Name">
                <o-input
                    maxlength="80"
                    placeholder="# e.g. plan-budget"
                    v-model="channel.name"
                ></o-input>
            </o-field>
            <o-field label="Make private">
                <o-switch v-model="channel.is_private" />
            </o-field>
        </section>
        <footer class="modal-card-foot">
            <button
                class="button"
                type="button"
               @click="$parent.$parent.$emit('update:active', false)"
            >Close</button>
            <button
                class="button is-primary"
                :disabled="loading"
                @click.prevent="handleSubmit"
            >{{loading ? 'Saving...' : 'Save'}}</button>
        </footer>
    </div>
</template>

<script>
import { create_channel } from '../../slack_api'
export default {
    data() {
        return {
            channel: {},
            loading: false,
        }
    },
    methods: {
        handleSubmit() {
            this.loading = true
            create_channel(this.channel)
                .then(r => {
                    this.loading = false
                    if (!r.ok) {
                        this.errorMessage('Error creating channel')
                        console.log('error', r)
                        return
                    }
                    this.$parent.$parent.$emit('update:active', false)
                    this.successMessage('Channel created successfull')
                    this.$emit('onSaved', r.channel)
                    return r
                }, (r) => {
                    this.loading = false
                    this.errorMessage('Error creating channel')
                    console.log('error', r)
                })
        },
    }
}
</script>